<template lang="html">
  <div>
    <v-card>
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
              >
                <v-list-item
                  :to="'/projects/' + project.id + form.path"
                  class="text-left"
                >
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item.tab">
          {{ $t(item.tab) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.tab" class="px-6 pb-6">
          <component
                  :is="item.content"
                  :project_id="item.project_id"
          />
        </v-tab-item>
      </v-tabs-items>

      <v-row>
        <v-col class="text-center mt-6">
          <v-btn
            type="submit"
            class="btn-large-space btn-danger mr-4"
            text
            v-on:click="$router.go(-1)"
            >{{ $t("button.back") }}</v-btn
          >
          <DeleteReasonBtn
            url-objects="project"
            object_type="project"
            :headers="headers"
            :item="project"
          />
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-6 text-center"></div>
  </div>
</template>

<script type="text/javascript">
import DeleteReasonBtn from "../delete_object/DeleteObjectForm";
import DetailDataProject from "./DetailDataProject";
import DetailConsortium from "./DetailConsortium";
import DetailSubprojects from "./DetailSubprojects";
import project_data from "../../mixins/project_data";
export default {
  mixins: [project_data],
  components: { DeleteReasonBtn, DetailDataProject, DetailConsortium, DetailSubprojects },
  data() {
    return {
      tab: 0,
      forms: [
        {
          icon: "mdi-pencil",
          title: "project.forms.modifyProject",
          path: "/forms/modifyProjectForm"
        }
      ],
      items: [
        {
          tab: "project.basicData",
          content: "DetailDataProject",
          project_id: parseInt(this.$route.params.id)
        },
        {
          tab: "project.consortiumData",
          content: "DetailConsortium",
          project_id: parseInt(this.$route.params.id)
        },
        {
          tab: "project.subprojectsData",
          content: "DetailSubprojects",
          project_id: parseInt(this.$route.params.id)
        },
    ]
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("form.title"),
          value: "title[gl]"
        }
      ];
    }
  },

  created() {
    this.getProjectWithBreadCrumb(this.$store.state.endpoint + "/project/" + this.$route.params.id);
  }

};
</script>
